"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "BrightCovePlayerModal", {
  enumerable: true,
  get: function get() {
    return _BrightcovePlayer["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrightcovePlayer = _interopRequireDefault(require("./BrightcovePlayer.modal"));

var _BrightcovePlayer2 = _interopRequireDefault(require("./BrightcovePlayer.player"));

// eslint-disable-next-line react/jsx-props-no-spreading
var VideoPlayer = function VideoPlayer(args) {
  return /*#__PURE__*/_react["default"].createElement(_BrightcovePlayer2["default"], args);
};

VideoPlayer.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "VideoPlayer"
};
var _default = VideoPlayer;
exports["default"] = _default;